export enum KEYS {
  Enter = "Enter",
  Backspace = "Backspace",
  ArrowDown = "ArrowDown",
  ArrowUp = "ArrowUp",
  Escape = "Escape",
  Tab = "Tab"
}